import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import TableRenderer from '../TableRenderer';

const AccordionDetail = ({ parentKey, parentValue, detail, detailData, detailLoading, colors, buildDetailTableData, masterData, onRowAction, onBulkAction, onGlobalAction, onOpenWorkspace, onConfigureTable }) => {
  const masterRow = masterData?.find((row) => String(row[parentKey]) === String(parentValue));
  const titleTemplate = detail.title || detail.label;
  const title = titleTemplate
    ? titleTemplate.replace(/\{\{(\w+)\}\}/g, (_, key) => {
        if (masterRow && masterRow[key] !== undefined) return masterRow[key];
        if (key === parentKey) return parentValue;
        return '';
      })
    : 'Details';

  if (detailLoading) {
    return (
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress size={24} sx={{ color: '#22c55e' }} />
      </Box>
    );
  }

  // Always render TableRenderer (even with empty data) so the toolbar/header actions show
  const table = buildDetailTableData(detail, detailData || [], title);

  // Detail-grid global (header) actions need the parent (master) row as context —
  // without it, an action like "Add Line" on the order-lines detail can't know
  // which order it belongs to. Wrap onGlobalAction to inject the masterRow as
  // the rowData parameter so the action handler treats it the same as a row
  // action on the master grid.
  const handleGlobalAction = (action) => {
    if (onGlobalAction) onGlobalAction(action, masterRow || null);
  };

  return (
    <TableRenderer
      table={table}
      colors={colors}
      onRowAction={onRowAction}
      onBulkAction={onBulkAction}
      onGlobalAction={handleGlobalAction}
      onOpenWorkspace={onOpenWorkspace}
      onConfigureTable={onConfigureTable}
    />
  );
};

export default AccordionDetail;
